import { type InputSignal } from '@angular/core';
import { type ParagraphModel } from '@big-direkt/utils/shared';

export abstract class ParagraphComponentBase<T = ParagraphModel> {
    // TODO: remove @Input from paragraphs and remove T as type. only input signals should be allowed
    public data?: T | InputSignal<undefined> | InputSignal<T>;
    public id?: string;
}
